export const MAKE_GRN_MODE_1_ACTION = 'MAKE_GRN_MODE_1_ACTION'
export const MAKE_GRN_MODE_1_ACTION_SUCCESS = 'MAKE_GRN_MODE_1_ACTION_SUCCESS'

export const CHALLAN_LIST_FOR_LIST_PAGE = 'CHALLAN_LIST_FOR_LIST_PAGE'
export const CHALLAN_LIST_FOR_LIST_PAGE_SUCCESS = 'CHALLAN_LIST_FOR_LIST_PAGE_SUCCESS'

export const ITEM_DROPDOWN_CHALLAN = 'ITEM_DROPDOWN_CHALLAN'
export const ITEM_DROPDOWN_CHALLAN_SUCCESS = 'ITEM_DROPDOWN_CHALLAN_SUCCESS'

export const CHALLAN_POST_API = 'CHALLAN_POST_API'
export const CHALLAN_POST_API_SUCCESS = 'CHALLAN_POST_API_SUCCESS'


export const VDC_ITEM = 'VDC_ITEM'
export const VDC_ITEM_SUCCESS = 'VDC_ITEM_SUCCESS'

export const VDC_ITEM_DETAILS = 'VDC_ITEM_DETAILS'
export const VDC_ITEM_DETAILS_SUCCESS = 'VDC_ITEM_DETAILS_SUCCESS'


export const CHALLAN_MASTER_BULK_ACTION = "CHALLAN_MASTER_BULK_ACTION";
export const CHALLAN_MASTER_BULK_SUCCESS = "CHALLAN_MASTER_BULK_SUCCESS";

export const DELETE_CHALLAN_FOR_CHALLAN_PAGE = 'DELETE_CHALLAN_FOR_GRN_PAGE'
export const DELETE_CHALLAN_FOR_CHALLAN_PAGE_SUCCESS = 'DELETE_CHALLAN_FOR_GRN_PAGE_SUCCESS'

export const GO_BUTTON_CHALLAN_POST_API = 'GO_BUTTON_CHALLAN_POST_API'
export const GO_BUTTON_CHALLAN_POST_API_SUCCESS = 'GO_BUTTON_CHALLAN_POST_API_SUCCESS'

export const MAKE_CHALLAN_ACTION = 'MAKE_CHALLAN_ACTION'
export const MAKE_CHALLAN_ACTION_SUCCESS = 'MAKE_CHALLAN_ACTION_SUCCESS'

export const GO_BUTTON_FOR_CHALLAN_ADD = 'GO_BUTTON_FOR_CHALLAN_ADD'
export const GO_BUTTON_FOR_CHALLAN_ADD_SUCCESS = 'GO_BUTTON_FOR_CHALLAN_ADD_SUCCESS'



export const IB_INVOICE_API_ERROR_ACTION = 'IB_INVOICE_API_ERROR_ACTION'









